module.exports = __webpack_public_path__ + "img/img.dbfc3335.png";